import { render, staticRenderFns } from "./website-identify-record.vue?vue&type=template&id=6031cbc6&scoped=true"
import script from "./website-identify-record.vue?vue&type=script&lang=js"
export * from "./website-identify-record.vue?vue&type=script&lang=js"
import style0 from "./website-identify-record.vue?vue&type=style&index=0&id=6031cbc6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6031cbc6",
  null
  
)

export default component.exports